/**
 * Image engine settings — see docs/image-engine-spec.md §2.3.
 *
 * Persistence scope (spec §11.3):
 *   per-book overridable → layout, direction, spreadOffset, pageGap, fit,
 *                          stretchSmallPages, maxWidth, maxHeight
 *   global only          → behavior, keymap, filters
 */
export const DEFAULT_IMAGE_SETTINGS = {
    layout: 'paged-single',
    direction: 'rtl',
    spreadOffset: 0,
    pageGap: 0,
    fit: 'contain',
    stretchSmallPages: false,
    maxWidth: null,
    maxHeight: null,
    headerVisible: true,
    progressBar: {
        style: 'normal',
        position: 'bottom',
        thickness: 4,
        showPageCounterWhenHidden: true,
    },
    cursorHint: 'overlay',
    background: 'theme',
    brightness: 1,
    greyscale: false,
    dim: false,
    tapToTurn: 'directional',
    scrollToTurn: 'off',
    chromeGesture: 'handle',
    doubleTapZoom: true,
    doubleClickFullscreen: false,
    nextChapterAfterLastPage: 'instant',
    historyMode: 'title',
    autoscroll: false,
    autoscrollSpeed: 46,
    autoscrollSmooth: true,
    pagedAutoAdvanceSeconds: 0,
    autoScrollUpOnFit: ['width', 'height'],
    autoScrollOffset: 0,
    preload: true,
    preloadStrategy: 'window',
    preloadAhead: 4,
    preloadBehind: 2,
    preloadAllMaxMB: 512,
    loadingMethod: 'blob',
};
//# sourceMappingURL=types.js.map